// @ts-strict-ignore
import {VNode} from 'snabbdom';

import {ItemClickEvent, ItemsMenuAttrs, ItemsMenuJsxProps, Section} from 'common/components/items-menu/types';

import type {ChangeEvent as SelectChangeEvent} from '../select/types';
import type {InputAttrs, InputComponent} from '../input';
import type {TagItem} from './tag-item';

export enum TagInputChangeAction {
  Text = `text`,
  AddTag = `addTag`,
  RemoveTag = `removeTag`,
}

export type TagInputChangeEvent = CustomEvent<
  | {tag: TagItem; action: TagInputChangeAction.RemoveTag}
  | {tag: TagItem; action: TagInputChangeAction.AddTag}
  | {value: string; action: TagInputChangeAction.Text}
>;

export type TagInputClearEvent = CustomEvent<EmptyObj>;

export enum TagInputSearchMode {
  /** Input text is used to filter tag menu */
  Text = `text`,
  /** Splits input text into words. If the last word is prefixed with "#", it is used to filter tag menu */
  Hashtag = `hashtag`,
  /** Input is treated like a combobox */
  Combobox = `combobox`,
}

type TagInputAttrs = InputAttrs & {
  'min-tags'?: number;
  'search-width'?: number;
  'menu-width'?: number | null;
  tags?: TagItem[];
  'disable-input'?: boolean;
  'search-mode'?: TagInputSearchMode;
  'mp-items-menu-attrs'?: ItemsMenuAttrs;
  multiline?: boolean;
  'controlled-mode'?: boolean;
  'combobox-mode'?: boolean;
};

export type TagInputJsxProps = {
  attrs?: Partial<TagInputAttrs>;
  props?: {
    value?: string;
    sectionsFromInputFn?: ItemsMenuJsxProps[`props`][`sectionsFromInputFn`];
    /** if specified, will render a menu of tags to select from */
    menuSections?: Section[];
    /** renders content next to the input element */
    suffixRenderer?: () => VNode | VNode[];
    openOnRefresh?: boolean;
    preserveSearchOnTagClick?: boolean;
  };
  on?: {
    clickMenuItem?: (ev: ItemClickEvent) => void;
    optionSelected?: (ev: SelectChangeEvent<TagItem>) => void;
    change?: (ev: TagInputChangeEvent) => void;
    clear?: (ev: TagInputClearEvent) => void;
  };
};

export type TagInputState = {
  openOnRefresh: null | boolean;
  preserveSearchOnTagClick: null | boolean;
  inputText: string;
  tagMap: Map<string, TagItem>;
  searchInputEl?: InputComponent;
  menuSections: null | Array<Section<TagItem>>;
  isMenuOpen: null | boolean;
  isFocused: null | boolean;
  suffixRenderer: null | (() => VNode | VNode[]);
  sectionsFromInputFn: ItemsMenuJsxProps[`props`][`sectionsFromInputFn`];
};
